import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthLoginResponse, AuthResponse, AuthService } from './auth.service';

@Component({
  selector: 'app-guard-auth',
  imports: [FormsModule],
  templateUrl: './guard-auth.component.html'
})
export class GuardAuthComponent {
  @Output() authenticated = new EventEmitter<AuthResponse>();
  @Output() backRequested = new EventEmitter<void>();

  protected username = '';
  protected password = '';
  protected guardAuthError = '';
  protected guardAuthLoading = false;

  private readonly authService = inject(AuthService);

  protected backToProfileSelection(): void {
    this.guardAuthError = '';
    this.backRequested.emit();
  }

  protected async authenticateGuard(event: Event): Promise<void> {
    event.preventDefault();
    this.guardAuthError = '';

    const username = this.username.trim();

    if (!username || !this.password) {
      this.guardAuthError = 'El usuario y la contrasena son obligatorios.';
      return;
    }

    this.guardAuthLoading = true;

    try {
      const response = await this.authService.loginGuard(username, this.password);

      if (response.ok) {
        const loginResponse = await response.json() as AuthLoginResponse;

        if (this.authService.isAuthResponse(loginResponse)) {
          this.authenticated.emit(loginResponse);
          return;
        }

        if (this.authService.isSecondFactorRequiredResponse(loginResponse)) {
          this.guardAuthError = 'Este acceso requiere doble factor. Actualiza el visor para completar la autenticacion.';
          return;
        }

        if (this.authService.isSecondFactorEnrollmentRequiredResponse(loginResponse)) {
          this.guardAuthError = 'Este acceso requiere configurar doble factor. Actualiza el visor para completar la autenticacion.';
          return;
        }

        this.guardAuthError = 'No se ha podido completar la autenticacion. Respuesta no reconocida.';
        return;
      }

      if (response.status === 401) {
        this.guardAuthError = 'El usuario o la contrasena no son correctos.';
        return;
      }

      this.guardAuthError = 'No se ha podido completar la autenticacion. Intentalo de nuevo mas tarde.';
    } catch {
      this.guardAuthError = 'No se ha podido contactar con el servicio de autenticacion.';
    } finally {
      this.guardAuthLoading = false;
    }
  }
}
